import { useEffect, useRef } from "react";

const MobileBanner = () => {
  const banner = useRef();
  const atOptions = {
    key: "c056e6af5edb7d76fea4b813f0223612",
    format: "iframe",
    height: 50,
    width: 320,
    params: {},
  };
  useEffect(() => {
    if (!banner.current.firstChild) {
      const conf = document.createElement("script");
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "//www.effectivecreativeformat.com/c056e6af5edb7d76fea4b813f0223612/invoke.js";
      conf.innerHTML = `atOptions = ${JSON.stringify(atOptions)}`;

      if (banner.current) {
        banner.current.append(conf);
        banner.current.append(script);
      }
    }
  }, [banner]);

  return (
    <div className="flex justify-center w-full">
      <div className="sm:hidden flex" ref={banner}></div>
    </div>
  );
};

export default MobileBanner;
